var MenuConfig = /** @class */ (function () {
    function MenuConfig() {
        this.defaults = {
            header: {
                self: {},
                clients: {
                    items: [
                        {
                            title: 'Partner',
                            root: true,
                            permission: ['sadmin'],
                            alignment: 'left',
                            page: '/clients/list-disti'
                        },
                        {
                            title: 'Market',
                            root: true,
                            permission: ['sadmin', 'distiadmin'],
                            alignment: 'left',
                            page: '/clients/list-market'
                        },
                        {
                            title: 'Client',
                            root: true,
                            permission: ['sadmin', 'distiadmin', 'marketadmin'],
                            alignment: 'left',
                            page: '/clients/list-customer'
                        },
                        {
                            title: 'Campus',
                            root: true,
                            permission: ['sadmin', 'distiadmin', 'marketadmin', 'clientadmin'],
                            alignment: 'left',
                            page: '/clients/list-campus'
                        }
                    ]
                },
                inventory: {
                    items: [
                        {
                            title: 'Campus',
                            root: true,
                            permission: ['sadmin', 'distiadmin', 'marketadmin'],
                            alignment: 'left',
                            page: '/inventory/campus'
                        },
                        {
                            title: 'Market',
                            root: true,
                            permission: ['sadmin', 'distiadmin', 'marketadmin'],
                            alignment: 'left',
                            page: '/inventory/market'
                        }
                    ]
                },
                machine: {
                    items: [
                        // {
                        // 	title: 'Home',
                        // 	root: true,
                        // 	permission: ['sadmin', 'distiadmin', 'clientadmin', 'campusadmin'],
                        // 	alignment: 'left',
                        // 	page: '/machine/sale'
                        // },
                        {
                            title: 'Drinks',
                            root: true,
                            permission: ['sadmin', 'distiadmin', 'marketadmin', 'clientadmin', 'campusadmin'],
                            alignment: 'left',
                            page: '/machine/sales'
                        },
                        {
                            title: 'Inventory',
                            root: true,
                            permission: ['sadmin', 'distiadmin', 'marketadmin', 'clientadmin', 'campusadmin'],
                            alignment: 'left',
                            toggle: 'click',
                            submenu: [
                                {
                                    title: 'Machine Inventory',
                                    permission: ['sadmin', 'distiadmin', 'marketadmin', 'clientadmin', 'campusadmin'],
                                    bullet: 'none',
                                    page: '/machine/inventory'
                                },
                                {
                                    title: 'Location Inventory',
                                    permission: ['sadmin', 'distiadmin', 'marketadmin', 'clientadmin', 'campusadmin'],
                                    bullet: 'none',
                                    page: '/machine/location-inventory'
                                },
                            ]
                        },
                        {
                            title: 'Alerts',
                            root: true,
                            permission: ['sadmin', 'distiadmin', 'marketadmin', 'clientadmin', 'campusadmin'],
                            alignment: 'left',
                            toggle: 'click',
                            submenu: [
                                {
                                    title: 'Open Issues',
                                    bullet: 'none',
                                    permission: ['sadmin', 'distiadmin', 'marketadmin', 'clientadmin', 'campusadmin'],
                                    page: '/machine/open-issues'
                                },
                                {
                                    title: 'Events',
                                    permission: ['sadmin', 'distiadmin', 'marketadmin', 'clientadmin', 'campusadmin'],
                                    bullet: 'none',
                                    page: '/machine/events'
                                },
                                {
                                    title: 'Errors & Warnings',
                                    permission: ['sadmin', 'distiadmin', 'marketadmin', 'clientadmin', 'campusadmin'],
                                    bullet: 'none',
                                    page: '/machine/logs'
                                }
                            ]
                        },
                        {
                            title: 'Settings',
                            root: true,
                            permission: ['sadmin', 'distiadmin', 'marketadmin'],
                            alignment: 'left',
                            toggle: 'click',
                            submenu: [
                                {
                                    title: 'Machine Details',
                                    permission: ['sadmin', 'distiadmin', 'marketadmin'],
                                    bullet: 'none',
                                    page: '/machine/details'
                                },
                                {
                                    title: 'S/W Version',
                                    permission: ['sadmin', 'distiadmin', 'marketadmin'],
                                    bullet: 'none',
                                    page: '/machine/updates'
                                },
                                {
                                    title: 'Settings',
                                    permission: ['sadmin'],
                                    bullet: 'none',
                                    page: '/machine/settings'
                                },
                                {
                                    title: 'Auger Purge',
                                    permission: ['sadmin'],
                                    bullet: 'none',
                                    page: '/machine/auger-purge'
                                },
                                {
                                    title: 'Canister Type',
                                    permission: ['sadmin'],
                                    bullet: 'none',
                                    page: '/machine/canister-type'
                                },
                                {
                                    title: 'Price Change',
                                    permission: ['sadmin', 'distiadmin', 'marketadmin'],
                                    bullet: 'none',
                                    page: '/machine/price-change'
                                },
                                {
                                    title: 'Card Reader',
                                    permission: ['sadmin', 'marketadmin'],
                                    featureFlag: 'card_reader_registration',
                                    bullet: 'none',
                                    page: '/machine/card-reader'
                                },
                                {
                                    title: 'Cold Brew',
                                    permission: ['sadmin'],
                                    featureFlag: 'cold_brew',
                                    bullet: 'none',
                                    page: '/machine/cold-brew'
                                }
                                // {
                                // 	title: 'Signal Strength',
                                // 	bullet: 'none',
                                // 	permission: ['sadmin', 'admin', 'rmgr', 'disti'],
                                // 	page: '/machine/signal'
                                // },
                                // {
                                // 	title: 'Connection Log',
                                // 	bullet: 'none',
                                // 	permission: ['sadmin', 'admin', 'rmgr', 'disti'],
                                // 	page: '/machine/conn-log'
                                // }
                            ]
                        },
                        {
                            title: 'Remote',
                            root: true,
                            permission: ['sadmin'],
                            alignment: 'left',
                            page: '/machine/remote'
                        },
                    ]
                },
                audits: {
                    items: [
                        {
                            title: 'Fleet',
                            root: true,
                            permission: ['sadmin'],
                            featureFlag: 'camera_audit',
                            alignment: 'left',
                            page: '/audits/fleet'
                        },
                        {
                            title: 'Triage',
                            root: true,
                            permission: ['sadmin'],
                            featureFlag: 'camera_audit',
                            alignment: 'left',
                            page: '/audits/triage'
                        },
                        {
                            title: 'Analytics',
                            root: true,
                            permission: ['sadmin'],
                            featureFlag: 'camera_audit',
                            alignment: 'left',
                            page: '/audits/analytics'
                        },
                    ]
                }
            },
            aside: {
                self: {},
                items: [
                    {
                        title: 'Dashboard',
                        root: true,
                        icon: 'flaticon-dashboard',
                        page: '/dashboard',
                        bullet: 'dot',
                    },
                    { section: 'Manage' },
                    {
                        title: 'Vouchers',
                        root: true,
                        icon: 'flaticon2-tag',
                        page: '/voucher',
                        bullet: 'dot',
                        permission: ['sadmin', 'campusadmin'],
                        featureFlag: 'vouchers',
                    },
                    // Hidden from the sidebar for now; the page still lives at /voucher-ops.
                    // {
                    // 	title: 'Voucher ops',
                    // 	root: true,
                    // 	icon: 'flaticon2-settings',
                    // 	page: '/voucher-ops',
                    // 	bullet: 'dot',
                    // 	permission: ['sadmin'],
                    // 	featureFlag: 'vouchers',
                    // },
                    {
                        title: 'Machines',
                        root: true,
                        bullet: 'dot',
                        // permission: ['sadmin'],
                        page: '/machine-list',
                        icon: 'flaticon-technology-2'
                    },
                    {
                        title: 'Card Readers',
                        root: true,
                        bullet: 'dot',
                        permission: ['sadmin'],
                        featureFlag: 'card_reader_list',
                        page: '/card-readers',
                        icon: 'lucide:SmartphoneNfc'
                    },
                    {
                        title: 'Cold Brew',
                        root: true,
                        bullet: 'dot',
                        permission: ['sadmin'],
                        featureFlag: 'cold_brew',
                        page: '/cold-brew',
                        icon: 'lucide:Snowflake'
                    },
                    {
                        title: 'Manage Clients',
                        root: true,
                        bullet: 'dot',
                        permission: ['sadmin'],
                        icon: 'flaticon-profile-1',
                        page: '/clients/list-disti'
                    },
                    {
                        title: 'Manage Clients',
                        root: true,
                        bullet: 'dot',
                        permission: ['distiadmin'],
                        icon: 'flaticon-profile-1',
                        page: '/clients/list-market'
                    },
                    {
                        title: 'Manage Clients',
                        root: true,
                        bullet: 'dot',
                        permission: ['marketadmin'],
                        icon: 'flaticon-profile-1',
                        page: '/clients/list-customer'
                    },
                    {
                        title: 'Manage Campuses',
                        root: true,
                        bullet: 'dot',
                        permission: ['clientadmin'],
                        icon: 'flaticon-profile-1',
                        page: '/clients/list-campus'
                    },
                    {
                        title: 'Inventory',
                        root: true,
                        bullet: 'dot',
                        icon: 'flaticon2-box',
                        page: '/inventory'
                    },
                    {
                        title: 'Orders',
                        root: true,
                        bullet: 'dot',
                        permission: ['sadmin', 'distiadmin', 'marketadmin', 'clientadmin', 'campusadmin'],
                        featureFlag: 'orders',
                        icon: 'flaticon2-shopping-cart',
                        page: '/orders'
                    },
                    {
                        title: 'VendiBean Flex',
                        root: true,
                        bullet: 'dot',
                        permission: ['sadmin'],
                        featureFlag: 'flex_mock',
                        icon: 'lucide:Shuffle',
                        page: '/flex',
                    },
                    { section: 'Utilities' },
                    {
                        title: 'Banners',
                        root: true,
                        bullet: 'dot',
                        // permission: ['sadmin'],
                        page: '/banners/assign-banner',
                        icon: 'flaticon2-line',
                    },
                    {
                        title: 'Analytics',
                        root: true,
                        bullet: 'dot',
                        page: '/analytics',
                        icon: 'flaticon2-analytics',
                    },
                    {
                        title: 'Retail Analytics',
                        root: true,
                        bullet: 'dot',
                        permission: ['sadmin'],
                        page: '/retail-analytics',
                        icon: 'lucide:ChartColumnStacked'
                    },
                    {
                        title: 'Manage Users',
                        root: true,
                        bullet: 'dot',
                        // permission: ['sadmin'],
                        icon: 'flaticon-rotate ',
                        page: '/users/list'
                    },
                    {
                        title: 'Bulk Update',
                        root: true,
                        bullet: 'dot',
                        permission: ['sadmin'],
                        icon: 'flaticon-open-box',
                        page: '/bulk-update'
                    },
                    {
                        title: 'Package',
                        root: true,
                        bullet: 'dot',
                        permission: ['sadmin'],
                        icon: 'flaticon2-delivery-package',
                        submenu: [
                            {
                                title: 'Upload',
                                bullet: 'dot',
                                page: '/package/upload'
                            },
                            {
                                title: 'Manage',
                                bullet: 'dot',
                                page: '/package/manage'
                            },
                            {
                                title: 'Bundle Spec',
                                bullet: 'dot',
                                page: '/package/bundlespec'
                            }
                        ]
                    },
                    {
                        title: 'Camera Audit',
                        root: true,
                        bullet: 'dot',
                        permission: ['sadmin'],
                        featureFlag: 'camera_audit',
                        page: '/audits/fleet',
                        icon: 'lucide:Focus',
                    },
                ]
            },
        };
    }
    Object.defineProperty(MenuConfig.prototype, "configs", {
        get: function () {
            return this.defaults;
        },
        enumerable: true,
        configurable: true
    });
    return MenuConfig;
}());
export { MenuConfig };
